/* eslint-disable no-useless-constructor */
import { Record } from 'immutable'
import { ACTIVITY_DEFAULT_IMAGE_DOMAIN_WITH_ID } from 'app/constants/activity'
import { IActivity } from 'store/entities/activity/interface'

export const CATEGORY_TAG_DEFAULT = { name: null, id: null }
export const STORY_DEFAULT = { story: null, id: null }
/**
 *
 * @type {*|Immutable.Record.Class}
 */
export const ActivityRecord = Record<IActivity>({
  id: null,
  day: null,
  name: null,
  image: null,
  videoId: null,
  videoThumbnail: null,
  description: null,
  proQuote: null,
  proQuoteAuthor: null,
  isValid: true,
  isFinished: null,
  actionType: null,
  deleting: false,
  pinned: false,
  invalid: false,
  example: false,
  level: null,
  fromFile: false,
  previousActionType: null,
  createdAt: null,
  proTrackLevelId: null,
  question: null,
  userActivityId: null,
  hasStory: false,
  isCommitted: false,
  story: STORY_DEFAULT,
  imageDomainWithId: ACTIVITY_DEFAULT_IMAGE_DOMAIN_WITH_ID,
  isImageLinkInvalid: false,
  categoryTag: CATEGORY_TAG_DEFAULT,
  categoryTagId: null,
  showErrorMessage: null,
  commitSmsCarrierResponse: null,
  committedSmsCarrierResponse: null,
  editStory: {
    editing: null,
    id: null,
    userActivityId: null,
  },
  userProTrackLevelId: null,
})

export class Activity extends ActivityRecord {
  constructor(props?: any) {
    super(props)
  }
}
